<template>
  <van-popup
    class="dialog-coupon"
    v-model="showPopup"
    :overlay-style="{
      backgroundColor: 'rgba(0, 0, 0, 0.6)'
    }"
    :close-on-click-overlay="false"
  >
    <div class="wrapper">
      <div class="header">
        <i class="close-icon" @click="close"></i>
        <img width="100%" :src="require('images/qingsu/channel/header.png')" />
        <div class="title">{{ title }}</div>
        <div class="tip">{{ tipTitle }}</div>
      </div>
      <div class="coupon-list">
        <coupon v-for="item in couponList" :key="item.couponId" v-bind="item" />
      </div>
      <div class="btn-use" @click="toUse">去使用</div>
    </div>
  </van-popup>
</template>

<script>
import { Popup } from 'vant'
import Coupon from './coupon'

export default {
  components: {
    [Popup.name]: Popup,
    Coupon
  },
  props: {
    page_popup: {
      type: Object,
      default: () => ({})
    },
    couponList: {
      type: Array,
      default: () => []
    },
    userInfo: {
      type: Array,
      default: () => []
    }
  },
  computed: {
    userId() {
      if (this.userInfo && this.userInfo.id) {
        return this.userInfo.id
      }
      return ''
    },
    cid() {
      return this.$route.query.cid || ''
    },
    title() {
      return this.page_popup.paid_coupon_title || ''
    },
    tipTitle() {
      return this.page_popup.paid_coupon_subtitle || ''
    }
  },
  data() {
    return {
      showPopup: false
    }
  },
  created() {
    const cacheKey = this.getCacheKey('COUPON')
    const isOpen = this.getStorage(cacheKey)
    if (!isOpen && this.couponList.length) {
      localStorage.setItem(cacheKey, true)
      this.open()
    }
  },
  methods: {
    getCacheKey(type) {
      return this.userId
        ? `CHANNEL_${this.cid}_${this.userId}_${type}_OPEN`
        : `CHANNEL_${this.cid}_VISITOR_${type}_OPEN`
    },
    getStorage(key) {
      return JSON.parse(localStorage.getItem(key)) || ''
    },
    toUse() {
      this.close()
      this.$emit('toUse')
    },
    open() {
      this.showPopup = true
    },
    close() {
      this.showPopup = false
    }
  }
}
</script>

<style lang="scss" scoped>
.dialog-coupon {
  background: transparent;
  overflow: inherit;
  .wrapper {
    position: relative;
    width: 560px;
    background: #fff;
    border-radius: 30px;
    text-align: center;
    padding-bottom: 38px;
  }
  .close-icon {
    position: absolute;
    z-index: 1;
    width: 48px;
    height: 48px;
    top: -24px;
    right: -24px;
    background: url('~images/qingsu/channel/btn-close.png') no-repeat
      center/100%;
  }
  .title {
    margin-top: 19px;
    font-size: 32px;
    font-weight: 600;
    color: #21252d;
    line-height: 48px;
  }
  .tip {
    margin-top: 10px;
    font-size: 28px;
    color: #6c798c;
    line-height: 46px;
  }
  .coupon-list {
    margin-top: 8px;
    max-height: 388px;
    padding: 8px 0;
    box-sizing: border-box;
    overflow-y: scroll;
    -webkit-overflow-scrolling: touch;
    border-radius: 30px;
    &::-webkit-scrollbar {
      display: none;
    }
  }
  .btn-use {
    position: relative;
    width: 512px;
    height: 86px;
    margin: 4px auto 0;
    background: linear-gradient(360deg, #ff6400 0%, #fff5cf 100%);
    border-radius: 48px;
    font-size: 32px;
    font-weight: 600;
    color: #fff;
    @include flex(row, center, center);
    &::before {
      position: absolute;
      content: '';
      height: 52px;
      left: -2px;
      right: -2px;
      top: -52px;
      background: linear-gradient(
        rgba(255, 255, 255, 0) 24px,
        rgba(255, 255, 255, 1) 95%
      );
    }
  }
}
</style>
